<rcl-section-header id="mock-login-section-header">
    <rcl-section-title id="mock-login-section-header__title">Welcome to Check-in Web</rcl-section-title>
    <rcl-section-description id="mock-login-section-header__description">Please begin your checkin process
    </rcl-section-description>
</rcl-section-header>
<div class="rcl-row">
    <div *ngIf="accessTokenFromCookies && olciDataFromCookies" class="custom-alert">
        <h5 class="rcl-h5">Cookies <span style="font-style: italic;"> AccessToken </span> and <span
                style="font-style: italic;"> OlciData </span> already exist, click <button id="mock-login-login-button"
                class="rcg-text-link" (click)="login()">here</button> to skip the login process. The validity of the
            AccessToken is not guaranteed.</h5>
    </div>
    <h4 class="rcl-h4">To start your <span style="font-style: italic;font-weight: 800;"> check-in </span>process, you
        can fill out the form or simply paste the required cookies.</h4>
</div>
<div class="rcl-row">
    <button class="rcl-button-text collapsible" id="complete-form__button" [class.active]="formOption"
        (click)="expandCompleteForm()">Complete form</button>
</div>
<form id="login-form" [formGroup]="loginForm" novalidate *ngIf="formOption">
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'First Name'"
            [control]="'firstName'">
            <rcl-error-message *ngFor="let error of errors?.firstName">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Last Name'"
            [control]="'lastName'">
            <rcl-error-message *ngFor="let error of errors?.lastName">{{ error }}</rcl-error-message>
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Email'"
            [control]="'email'">
            <rcl-error-message *ngFor="let error of errors?.email">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'"
            [label]="'DOB mm/dd/yyyy'" [control]="'dob'">
            <rcl-error-message *ngFor="let error of errors?.dob">{{ error }}</rcl-error-message>
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'GA vdsId'"
            [control]="'vdsId'">
            <rcl-error-message *ngFor="let error of errors?.vdsId">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Guest Id'"
            [control]="'guestId'">
            <rcl-error-message *ngFor="let error of errors?.guestId">{{ error }}</rcl-error-message>
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Booking Id'"
            [control]="'bookingId'">
            <rcl-error-message *ngFor="let error of errors?.bookingId">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'"
            [label]="'Sail Date yyyy-mm-dd'" [control]="'sailDate'">
            <rcl-error-message *ngFor="let error of errors?.sailDate">{{ error }}</rcl-error-message>
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Ship Code'"
            [control]="'shipCode'">
            <rcl-error-message *ngFor="let error of errors?.shipCode">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-select class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [control]="'locale'" [id]="'locale'"
            [label]="'Locale'">
            <rcl-option *ngFor="let locale of localeArray; let index = index"
                [ariaLabel]="'locale'" [id]="locale"
                [value]="locale" [viewValue]="locale"></rcl-option>
            <rcl-error-message *ngFor="let error of errors?.locale">{{ error }} </rcl-error-message>
        </rcl-select>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Access Token'"
            [control]="'accessToken'">
            <rcl-error-message *ngFor="let error of errors?.accessToken">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcg-radio-group-v2
            class="rcl-col-sm-12 rcl-col-md-6"
            [mode]="brandName" 
            [disabled]="false" 
            [options]="charterOptionsString"
            [control]="'charterSailing'"
            [name]="'charterSailing'"
            [arialabel]="'Is Charter Sailing'"
            [value]="selectedCharterOption"
            (optionSelected)="onCharterOptionSelected($event)"
            [layout]="layout">
        </rcg-radio-group-v2>
        <rcl-error-message *ngFor="let error of errors?.charterSailing">{{ error }}</rcl-error-message>
    </div>

    <div class="rcl-row" style="justify-content: flex-end;">
        <rcg-primary-button 
            type="button" 
            text="Continue" 
            (click)="saveFormValues()"
            (keydown.enter)="saveFormValues()"         
        ></rcg-primary-button>
    </div>
</form>

<div class="rcl-row">
    <button class="rcl-button-text collapsible" id="paste-cookies__button" [ngClass]="{ 'active': cookiesOption }"
        (click)="expandPasteCookies()">Paste cookies</button>
</div>
<form id="cookies-form" [formGroup]="cookiesForm" novalidate *ngIf="cookiesOption">
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-12" [group]="cookiesForm" [type]="'text'" [label]="'Olci Data'"
            [control]="'olciData'">
            <rcl-error-message *ngFor="let error of errors?.olciData">{{ error }}</rcl-error-message>
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-12" [group]="cookiesForm" [type]="'text'"
            [label]="'Access Token'" [control]="'accessToken'">
            <rcl-error-message *ngFor="let error of errors?.accessToken">{{ error }}</rcl-error-message>
        </rcl-text-field>
    </div>

    <div class="rcl-row" style="justify-content: flex-end;">
        <rcg-primary-button 
            type="button" 
            text="Continue" 
            (click)="setCookies()"
            (keydown.enter)="setCookies()"
        ></rcg-primary-button>
    </div>
</form>
<br />
<br />
<br />
